import { render, staticRenderFns } from "./warehouseVetUpload.vue?vue&type=template&id=bc43c482&scoped=true&"
import script from "./warehouseVetUpload.vue?vue&type=script&lang=js&"
export * from "./warehouseVetUpload.vue?vue&type=script&lang=js&"
import style0 from "./warehouseVetUpload.vue?vue&type=style&index=0&id=bc43c482&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc43c482",
  null
  
)

export default component.exports